/**
 * Helper (pure) ของ "version list" ของ asset ต่อ scene (GET /version/{thread}/segment/{id}/{type})
 *
 * ทำไมต้องมี: หลังบ้านตอบ 404 "segment not found" เมื่อ manifest ยังไม่มี scene นั้น ซึ่งเกิดได้ปกติ —
 * run เก่าก่อนมีระบบ version ที่ยังไม่เคย generate ใหม่ · manifest อยู่บน S3 แต่ route นี้ไม่ sync ลง worker ·
 * scene ที่เพิ่งเพิ่มและยังไม่เคย generate ⇒ ต้องถือเป็น "ยังไม่มี version" ไม่ใช่ error
 * (เคยทำให้ snack เด้งมั่วจนถูก comment ทิ้ง)
 */
import { AssetType, DirectScriptOutputItem, SegmentVersionResponse } from "../types/MeGenTypes";

/** asset ของ scene นี้ที่ "มีของแล้ว" ตาม output ล่าสุด — auto-fetch version list เฉพาะพวกนี้
 *  (video ไม่ auto-fetch เหมือนเดิม — ผู้ใช้กดปุ่ม Version เอง) */
export const versionAssetTypesFor = (
  item: Pick<DirectScriptOutputItem, "audio_url" | "image_url"> | null | undefined,
): AssetType[] => {
  if (!item) return [];
  const types: AssetType[] = [];
  if (item.audio_url) types.push("audio");
  if (item.image_url) types.push("image");
  return types;
};

/** response เทียบเท่า "ยังไม่มี version" — รูปเดียวกับที่หลังบ้านคืน (200)
 *  เมื่อ segment มีแต่ asset ชนิดนั้นยังไม่มี */
export const emptySegmentVersions = (segmentId: string, assetType: AssetType): SegmentVersionResponse => ({
  segment_id: segmentId,
  asset_type: assetType,
  current: null,
  versions: [],
});

/** key ของ panel เลือก version ที่เปิดค้างอยู่ (scene + ชนิด asset) */
export type VersionPanelKey = { itemId: string; assetType: AssetType };

/** ปิด panel ได้ก็ต่อเมื่อ error ที่มาถึงเป็นของ panel ที่เปิดอยู่จริง
 *  (response ที่มาช้าจากคลิกก่อนหน้าต้องไม่ปิด panel ของ scene/asset ที่ผู้ใช้เพิ่งเปิด) */
export const closeVersionPanelOn = (
  prev: VersionPanelKey | null,
  failed: VersionPanelKey,
): VersionPanelKey | null =>
  prev && prev.itemId === failed.itemId && prev.assetType === failed.assetType ? null : prev;
